import { useMemo } from 'react';
import { useQuery } from '@tanstack/react-query';
import { processTimelineData } from '../utils/timeline-processing';
import { WebsiteViewService } from 'src/model/WebsiteViewService';
import { WEBSITE_EVENTS_QUERY_KEY } from 'src/components/shared-panels/useWebsiteRunStatus';

export const useTimelineData = (websiteId: string) => {
  const queryResult = useQuery({
    // Named rather than spelt inline, because the funnel's status badge reads the same response from the same
    // key: shared by a matching string literal, one of them could be renamed without the other noticing.
    queryKey: [WEBSITE_EVENTS_QUERY_KEY, websiteId],
    queryFn: () => new WebsiteViewService().getWebsiteEvents(websiteId || ''),
    enabled: !!websiteId,
    staleTime: 5 * 60 * 1000, // 5 minutes
    cacheTime: 10 * 60 * 1000, // 10 minutes
    retry: 3,
    retryDelay: attemptIndex => Math.min(1000 * 2 ** attemptIndex, 30000),
  });

  const processedData = useMemo(() => processTimelineData(queryResult.data), [queryResult.data]);

  return {
    ...queryResult,
    ...processedData,
  };
};
